<template>
  <card>
    <div slot="header">
      <h4 v-show="!isModal" class="title">{{ title }}</h4>
    </div>
    <div>
      <form>
        <div class="row">
          <div class="col-xl-4 form-row-top">
            <div>Current Value:</div>
            <fg-input
              type="number"
              placeholder="Enter the current value"
              v-model="portfolio.value"
              v-on:change="valueChanged()"
            ></fg-input>
          </div>
          <div class="col-xl-4 form-row-top">
            <div>Current Cost:</div>
            <fg-input
              type="number"
              placeholder="Enter current cost"
              v-model="portfolio.cost"
              v-on:change="valueChanged()"
            ></fg-input>
          </div>
          <div class="col-xl-4 form-row-top">
            <div>Current Ownership (%):</div>
            <fg-input
              type="number"
              placeholder="Enter ownership percent"
              v-model="portfolio.ownership"
              v-on:change="valueChanged()"
            ></fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 form-row-top">
            <div>Initial Investment:</div>
            <input
              class="url-form-field"
              type="date"
              :value="portfolio.initial_investment && moment.utc(portfolio.initial_investment).format('YYYY-MM-DD')"
              @input="portfolio.initial_investment = moment($event.target.valueAsDate)"
              v-on:change="valueChanged()"
            />
            <!-- <fg-input type="date"
            placeholder="mm / dd / yyyy"
            v-model="portfolio.initial_investment">
            </fg-input>-->
          </div>
          <div class="col-xl-4 form-row-top">
            <div>Last Funding Round:</div>
            <!--fg-input can have label=""-->
            <input
              class="url-form-field"
              type="date"
              :value="(portfolio.last_funding_round && moment.utc(portfolio.last_funding_round).format('YYYY-MM-DD')) || lastFundingRound "
              @input="portfolio.last_funding_round = moment($event.target.valueAsDate)"
              v-on:change="valueChanged()"
            />
          </div>
          <div class="col-xl-4 form-row-top">
            <div>Direct/LP:</div>
            <el-select
              class=""
              size="large"
              placeholder="Select Status"
              v-model="portfolio.direct"
              v-on:change="valueChanged()"
            >
              <el-option
                v-for="option in vals.PORTFOLIO.DIRECT_LP"
                class=""
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="col-xl-4 form-row-top">
            <div>Context:</div>
            <el-select class=""
            size="large"
            placeholder="Select Status"
            v-model="portfolio.context">
            <el-option v-for="option in vals.PORTFOLIO.CONTEXT"
              class=""
              :value="option"
              :label="option"
              :key="option"></el-option>
            </el-select>
          </div>-->
        </div>

        <div class="row">
          <div class="col-xl-4 form-row-top">
            <div>Stage I Invested:</div>

            <el-select
              class=""
              size="large"
              placeholder="Select Stage"
              v-model="portfolio.stage_i_invested"
              v-on:change="valueChanged()"
            >
              <el-option
                v-for="option in vals.STAGE_DEFINES"
                class=""
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </div>
          <div class="col-xl-4 form-row-top">
            <div>Tag:</div>
            <fg-input
              type="text"
              placeholder="Enter Tag"
              v-model="portfolio.fund"
              v-on:change="valueChanged()"
            ></fg-input>
          </div>
          <div class="col-xl-4 form-row-top">
            <div>Pro Rata Rights</div>
            <input
              type="checkbox"
              v-model="portfolio.pro_rata_rights"
              v-on:change="valueChanged()"
              class="form-control"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-xl form-row-top">
            <div class="required" style="padding-bottom: 10px;">* Indicates a required field</div>
          </div>
        </div>
        <div v-if="isModal" class="row">
          <!-- show these buttons if we are a modal -->
          <div class="actionbuttons">
            <button @click="cancel" class="btn btn-info btn-fill btn-wd">Cancel</button>
            <button @click="save" class="btn btn-info btn-fill btn-wd">Save</button>
          </div>
        </div>
      </form>
    </div>
  </card>
</template>
<script>
import Card from "../Card.vue";
import { vals } from "../../../util";
import { Select, Option } from "element-ui";
import moment from "moment";
export default {
  name: "portfolio-edit-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Card
  },
  computed: {
    moment() {
      return moment;
    },
    vals() {
      return vals;
    },
    lastFundingRound() {
      if (
        this.portfolio.funding_rounds &&
        this.portfolio.funding_rounds.list &&
        this.portfolio.funding_rounds.list.length &&
        this.portfolio.funding_rounds.list[0].announced_date
      ) {
        return moment
          .utc(this.portfolio.funding_rounds.list[0].announced_date)
          .format("YYYY-MM-DD");
      }

      return "";
    }
  },
  data() {
    return {
    };
  },
  props: {
    isModal: {
      type: Boolean,
      default() {
        return false;
      }
    },
    title: {
      type: String
    },
    portfolio: {
      type: Object,
      default() {
        return { direct_lp: "direct" };
      }
    },
    context: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    save() {
      // unsure if we need to actually return info...
      this.$emit("portfolio-edit-card-close", this.context, { confirm: true });
    },
    cancel() {
      this.$emit("portfolio-edit-card-close", this.context);
    },
    valueChanged() {
      this.$emit("card-onchange");
    }
  }
};
</script>
<style>
</style>
